<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.35,791.07v-5.71L5.4,782.5l-4.9,2.83l-4.9-2.83l-4.95,2.86v5.71l4.95,2.85l-0.01,0.01v5.71l4.95,2.86l4.95-2.86v-5.71
	l-0.05-0.03L10.35,791.07z M-5.06,790.78c0.03,0.2,0.08,0.34,0.16,0.44c0.15,0.18,0.4,0.27,0.75,0.27c0.21,0,0.39-0.02,0.52-0.07
	c0.25-0.09,0.38-0.26,0.38-0.5c0-0.14-0.06-0.25-0.19-0.33c-0.13-0.08-0.32-0.14-0.59-0.2l-0.46-0.1c-0.45-0.1-0.76-0.21-0.93-0.33
	c-0.29-0.2-0.44-0.51-0.44-0.93c0-0.39,0.14-0.71,0.42-0.96s0.69-0.38,1.24-0.38c0.46,0,0.84,0.12,1.16,0.36s0.49,0.59,0.51,1.05
	h-0.87c-0.02-0.26-0.13-0.44-0.34-0.55c-0.14-0.07-0.32-0.11-0.52-0.11c-0.23,0-0.42,0.05-0.56,0.14s-0.21,0.22-0.21,0.39
	c0,0.15,0.07,0.27,0.21,0.35c0.09,0.05,0.28,0.11,0.56,0.18l0.74,0.18c0.33,0.08,0.57,0.18,0.74,0.31c0.26,0.2,0.39,0.5,0.39,0.88
	c0,0.39-0.15,0.72-0.45,0.98s-0.73,0.39-1.28,0.39c-0.56,0-1-0.13-1.33-0.38s-0.48-0.61-0.48-1.06H-5.06z M-1.78,787.79h0.9v4.32
	h-0.9V787.79z M-0.35,791.35l2.23-2.79h-2.17v-0.76h3.3v0.72l-2.26,2.83h2.26v0.76h-3.36V791.35z M6.82,788.56H4.53v0.92h2.1v0.75
	h-2.1v1.11h2.39v0.78H3.65v-4.32h3.17V788.56z M-0.98,798.11c0.01-0.3,0.07-0.58,0.2-0.83c0.12-0.28,0.4-0.58,0.84-0.9
	c0.38-0.28,0.63-0.47,0.75-0.59c0.17-0.19,0.26-0.39,0.26-0.61c0-0.18-0.05-0.33-0.15-0.45s-0.24-0.18-0.43-0.18
	c-0.25,0-0.43,0.09-0.52,0.28c-0.05,0.11-0.08,0.28-0.09,0.52h-0.81c0.01-0.36,0.08-0.65,0.2-0.88c0.22-0.42,0.62-0.64,1.19-0.64
	c0.45,0,0.81,0.13,1.07,0.37s0.4,0.58,0.4,0.99c0,0.31-0.09,0.59-0.28,0.84c-0.12,0.16-0.33,0.34-0.61,0.54l-0.33,0.24
	c-0.21,0.15-0.35,0.26-0.43,0.32s-0.14,0.14-0.19,0.23h1.85v0.74H-0.98z"/>
</svg>

</template>